import classnames from "classnames";
import Proptypes from "prop-types";
import styles from "./index.css";

const NoItems = ({
  Icon,
  title,
  titleStyle,
  messages,
  messagesStyle,
  Button
}) => (
  <div className={styles.noItems}>
    {Icon ? <Icon /> : null}
    <h2 className={classnames(styles.noItemsTitle, titleStyle)}>{title}</h2>
    <span className={classnames(styles.noItemsMessages, messagesStyle)}>
      {messages.map((message, index) => (
        <p key={index}>{message}</p>
      ))}
    </span>
    <Button className={styles.noItemsButton} />
  </div>
);

NoItems.propTypes = {
  Icon: Proptypes.func,
  title: Proptypes.string.isRequired,
  titleStyle: Proptypes.string,
  messages: Proptypes.arrayOf(Proptypes.string).isRequired,
  messagesStyle: Proptypes.string,
  Button: Proptypes.elementType.isRequired
};

export default NoItems;
